import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "components";
import wavingHand from "assets/images/waving-hand.png";

const Welcome = ({ headerText }) => {
  const { user } = useSelector((state) => state.user);
  return (
    <div className="d-flex flex-column flex-md-row justify-content-between align-content-center">
      <Typography variant="heading3" state="primary" component="h3">
        {headerText ? (
          headerText
        ) : (
          <>
            {" "}
            Welcome {user?.corporate_name || user?.firstname}{" "}
            <img src={wavingHand} width="30" alt="" />,
          </>
        )}
      </Typography>
    </div>
  );
};

export default Welcome;
